const AuthReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN": {
      console.log("LOGIN CASE ")
      return {
        currentUser: action.payload,
      };
    }
    case "LOGOUT": {
      console.log("INSIDE LOGOUTTT")
      return {
        currentUser: null,
      };
    }
    default:
      return state;
  }
};

export default AuthReducer;
